
const getInitialValues = (categories) => {
  const menuButtons = categories.filter(el => el.type === 'menu')
  return menuButtons.reduce((result, el) => {
    return result.concat(el.code)
  }, [])
}

export default getInitialValues



// WEBPACK FOOTER //
// ./src/mapSetup/getInitialValues.js